<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useStore } from 'dashboard/composables/store';
import NextButton from 'dashboard/components-next/button/Button.vue';
import ConversationApi from 'dashboard/api/conversations';
import FeaturePlaceholder from './FeaturePlaceholder.vue';

defineProps({
  message: {
    type: String,
    required: true,
  },
  showRefreshButton: {
    type: Boolean,
    default: true,
  },
});

const { t } = useI18n();
const store = useStore();
const isRefreshing = ref(false);

const handleRefreshWorkspace = async () => {
  if (isRefreshing.value) return;
  isRefreshing.value = true;
  try {
    const response = await ConversationApi.getWorkspaceStatus();
    await store.dispatch('fetchAllConversations', { replaceExisting: true });
    await store.dispatch('inboxes/get');
    const alertMsg =
      response?.data?.message || t('CONVERSATION.REFRESH_WORKSPACE_SUCCESS');
    useAlert(alertMsg);
  } catch (error) {
    await store.dispatch('fetchAllConversations', { replaceExisting: true });
    useAlert(t('CONVERSATION.REFRESH_WORKSPACE_SUCCESS'));
  } finally {
    isRefreshing.value = false;
  }
};
</script>

<template>
  <div class="flex flex-col items-center justify-center h-full">
    <img
      class="m-4 w-32 hidden dark:block"
      src="dashboard/assets/images/no-chat-dark.svg"
      alt="No Chat dark"
    />
    <img
      class="m-4 w-32 block dark:hidden"
      src="dashboard/assets/images/no-chat.svg"
      alt="No Chat"
    />
    <span class="text-sm text-n-slate-12 font-medium text-center">
      {{ message }}
      <br />
    </span>
    <div v-if="showRefreshButton" class="mt-4 flex flex-col items-center">
      <NextButton
        id="refresh-workspace-button"
        color="slate"
        size="sm"
        icon="i-lucide-refresh-cw"
        :is-loading="isRefreshing"
        :label="$t('CONVERSATION.REFRESH_WORKSPACE_DATA')"
        class="shadow-sm hover:shadow"
        @click="handleRefreshWorkspace"
      />
    </div>
    <!-- Cmd bar, keyboard shortcuts placeholder -->
    <FeaturePlaceholder />
  </div>
</template>
